const baseScale = 6;

export const SCALE_1 = `${baseScale}px`;
export const SCALE_2 = `${baseScale * 2}px`;
export const SCALE_3 = `${baseScale * 3}px`;
export const SCALE_4 = `${baseScale * 3}px`;

export const SCALE_5 = `${baseScale * 5}px`;
